import React, { PropsWithChildren } from 'react';
import { useDispatch } from 'react-redux';
import { navigateBy } from '../../navigation/thunks/navigate-by.thunk';
import { Column } from '../contexts/column.context';
import { STRIP_WIDTH } from '../utils/graph.utils';
import { StripContent } from './StripContent';
import { EventHandler, StripInteractions } from './StripInteractions';
import { useStripInfo } from '../contexts/strip.context';
import { setCurrentLeads } from '../../wave/thunks/set-current-leads.thunk';

type Props = PropsWithChildren<{
  width?: number;
}>;

export const EditableStrip: React.FC<Props> = ({
  children,
  width = STRIP_WIDTH,
}) => {
  const dispatch = useDispatch();
  const { stripId } = useStripInfo();

  const handler: EventHandler = (eventType, offset) => {
    switch (eventType) {
      case 'wheel':
        dispatch(navigateBy(offset));
        break;
      case 'mousemove':
        dispatch(setCurrentLeads(stripId));
        break;
    }
  };

  return (
    <Column width={width}>
      <StripContent clipType='vertical' data-testid='strip-content'>
        <StripInteractions eventHandler={handler}>{children}</StripInteractions>
      </StripContent>
    </Column>
  );
};
